import { LabelConfigurationWarningMode } from '../../../../helper/enum/LabelConfigurationType';

export const P00039EclairageNameEnum = [
  { ref: 0, label: 'Standard' },
  { ref: 1, label: 'WA' },
  { ref: 2, label: 'WELTICO' },
  { ref: 3, label: 'WELTICO V2 COULEUR' },
  { ref: 4, label: 'WELTICO V2 BLANC' },
];

export const P00039EclairageTypeEnumFn = (acu: number) => [
  { ref: 0, label: 'Standard', value: 0 },
  {
    ref: 1,
    label: 'FAMILLE WELTILED COULEUR',
    value: 3,
    warningMode:
      acu < 9
        ? LabelConfigurationWarningMode.NEED_UPDATE
        : acu === 9
          ? LabelConfigurationWarningMode.NEW
          : null,
  },
  {
    ref: 2,
    label: 'FAMILLE WELTILED BLANC',
    value: 4,
    warningMode:
      acu < 9
        ? LabelConfigurationWarningMode.NEED_UPDATE
        : acu === 9
          ? LabelConfigurationWarningMode.NEW
          : null,
  },
  { ref: 3, label: 'POOL LIGHT BLANC (WA)', value: 1 },
  { ref: 4, label: 'POOL LIGHT COULEUR (WA)', value: 1 },
  { ref: 5, label: 'STAIR LIGHT BLANC (WA)', value: 1 },
  { ref: 6, label: 'STAIR LIGHT COULEUR (WA) ', value: 1 },
  { ref: 7, label: 'WELTICO STANDARD BLANC ', value: 2 },
  { ref: 8, label: 'WELTICO STANDARD COULEUR ', value: 2 },
  { ref: 9, label: 'WELTICO SPOTTIE BLANC ', value: 2 },
  { ref: 10, label: 'WELTICO SPOTTIE COULEUR ', value: 2 },
];
